// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".selected-articles__button[data-v-1f9a7e10]{text-align:left;width:100%}.selected-articles__button-icon[data-v-1f9a7e10]{float:right}.selected-articles__title--large[data-v-1f9a7e10]{font-size:26px;font-weight:600}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
